import React from "react";

import { Navbar } from "../../../components";
import { CodamMentoring } from "./CodamMentoring";

const CodamMentoringProject = () => {
  return (
    <div className="app">
      <Navbar />
      <CodamMentoring />
    </div>
  );
};

export default CodamMentoringProject;
